import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-m-2 p-my-4" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-mx-2 p-my-4" }
const _hoisted_5 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")

  return (_ctx.data)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.data.missingColumns.length > 0 ? _ctx.$t('metaweb.updatePhysicalModel.addNewColumns') : _ctx.$t('metaweb.updatePhysicalModel.noNewColumns')), 1),
          (_ctx.data.missingColumns.length > 0)
            ? (_openBlock(), _createBlock(_component_Listbox, {
                key: 0,
                class: "metaweb-update-changed-list ",
                options: _ctx.data.missingColumns,
                disabled: true
              }, null, 8, ["options"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.data.removingItems.length > 0 ? _ctx.$t('metaweb.updatePhysicalModel.deletedColumns') : _ctx.$t('metaweb.updatePhysicalModel.noDeletedColumns')), 1),
          (_ctx.data.removingItems.length > 0)
            ? (_openBlock(), _createBlock(_component_Listbox, {
                key: 0,
                class: "metaweb-update-changed-list ",
                options: _ctx.data.removingItems,
                disabled: true
              }, null, 8, ["options"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}